import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import StaticLayoutInner from '@/layouts/StaticLayoutInner';
import EditProjectHeader from '@/pages/settings/EditProject/EditProjectHeader';
import { OutletContext } from '@/types';
import TeamTable from '@/pages/settings/EditProject/TeamTable';
import PlusIcon from '@/images/icons/Plus';
import NewMemberModal from './NewMemberModal';
import RemoveMemberModal from '@/pages/settings/EditProject/RemoveMemberModal';

function Team() {
	const { project } = useOutletContext<OutletContext>();

	const [newMemberModalOpen, setNewMemberModalOpen] = useState(false);
	const [removeMemberModalOpen, setRemoveMemberModalOpen] = useState(false);
	const [memberToRemove, setMemberToRemove] = useState(null);
	const [filters, setFilters] = useState(undefined);

	return (
		<StaticLayoutInner>
			<EditProjectHeader project={project} />
			<button className="btn-secondary mb-8" onClick={() => setNewMemberModalOpen(true)}>
				Add new member
				<PlusIcon className="w-5 h-5 ml-1 -mr-1" />
			</button>
			<TeamTable
				pageSize={10}
				setRemoveMemberModalOpen={setRemoveMemberModalOpen}
				setMemberToRemove={setMemberToRemove}
				filters={filters}
			/>

			<NewMemberModal
				modalOpen={newMemberModalOpen}
				setModalOpen={setNewMemberModalOpen}
				projectId={project.projectId}
			/>
			<RemoveMemberModal
				modalOpen={removeMemberModalOpen}
				setModalOpen={setRemoveMemberModalOpen}
				projectId={project.projectId}
				member={memberToRemove}
				setFilters={setFilters}
			/>
		</StaticLayoutInner>
	);
}

export default Team;
